import React, { useState, useEffect } from 'react';
import './App.css';
import Sidebar from './components/Sidebar/Sidebar';
import ChatContainer from './components/ChatContainer/ChatContainer';
import { IconButton, useMediaQuery } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

function App() {
    const [resetTrigger, setResetTrigger] = useState(0);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Closed by default on mobile
    const [isSimplifiedMode, setIsSimplifiedMode] = useState(false);

    // Determine if screen width matches desktop or mobile
    const isDesktop = useMediaQuery('(min-width:769px)');

    // Toggle sidebar open/close state
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Only at the beginning: trigger backend for a warm-up.
    useEffect(() => {
        fetch('https://rag-chatbot-europe-459709207650.europe-west4.run.app/warmup', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => console.log("Warm-up successful:", data))
            .catch(error => console.error("Warm-up error:", error));
    }, []);

    return (
        <div className="app-container">
            {/* "Skip to content" link */}
            <a href="#chat-input" className="skip-link" aria-label="Skip to content button">Skip to content</a>

            {!isDesktop && (
                <IconButton
                    aria-label="Toggle sidebar"
                    onClick={toggleSidebar}
                    className="sidebar-toggle-btn"
                    sx={{ display: { xs: 'block', md: 'none' }, position: 'absolute', left: 1, top: 3 }}
                >
                    <MenuIcon />
                </IconButton>
            )}

            <Sidebar
                resetMessages={() => setResetTrigger(prev => prev + 1)}
                isOpen={isSidebarOpen || isDesktop} // Open by default on desktop
                toggleSidebar={toggleSidebar}
                isSimplifiedMode={isSimplifiedMode}
                setIsSimplifiedMode={setIsSimplifiedMode}
                variant={isDesktop ? "persistent" : "temporary"} // Set variant based on screen size
            />

            <ChatContainer
                resetTrigger={resetTrigger}
                isSimplifiedMode={isSimplifiedMode}
                style={{ flexGrow: 1 }}
            />
        </div>
    );
}

export default App;
